/**
 * The collab-service WebSocket for this environment (PSTUDIO-4449).
 *
 * collab-service runs in-process in the admin backend and its `/collab` route is
 * served on the admin-backend hosts, so the socket is `FE_ADMIN_URL`'s origin
 * with the scheme swapped: `https://admin-backend.<env>…` →
 * `wss://admin-backend.<env>…/collab`.
 *
 * Returns `null` for anything that is not an http(s) URL, and the caller then
 * opens no session — a wrong socket URL would only ever surface as an endless
 * `offline` banner.
 */
export const buildCollabUrl = (adminUrl: string | undefined): string | null => {
  if (!adminUrl) return null;

  let parsed: URL;
  try {
    parsed = new URL(adminUrl);
  } catch {
    return null;
  }

  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;

  const scheme = parsed.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${scheme}//${parsed.host}/collab`;
};
